import React from 'react';
import { connect } from 'react-redux';
import { getUrlParams, getUrlString } from '../../../../utils/shared/urlUtils';
import StudentSummaryTable from '../../../../features/studentSummary/shared/benchmarkHistory/StudentSummaryTable';
import { selectors } from '../../../../root/reading/root';
import ExtendedTable from '../../../../components/extendedTable/ExtendedTable';
import CommonCellBuilder from '../../../../components/cell/reading/CommonCellBuilder';
import HistoricalDibelsBox from '../../../../features/studentSummary/reading/benchmarkHistory/HistoricalDibelsBox';
import openProbeDetails from '../../../../api/probeDetails/probeDetailsActions';
import { PARAM, URL } from '../../../../constants/reading/ApiConstants';
import ProbeDetailsPageContainer from '../../../probeDetails/reading/ProbeDetailsPageContainer';

const { ETERNAL_STUDENT_SID } = PARAM;
const { DIBELS_SEVEN_STUDENT_SUMMARY_URL } = URL;

const mapStateToProps = state => {
    const location = selectors.getLocation(state);
    const isDemoModeOn = selectors.getIsDemoModeOn(state);
    const classNames = isDemoModeOn ? 'history-link hide-link' : 'history-link';
    const { classe, studentId, resultId } = getUrlParams(location);
    const studentSummaryUrl = getUrlString(DIBELS_SEVEN_STUDENT_SUMMARY_URL, {
        [ETERNAL_STUDENT_SID]: studentId,
        classe,
    });

    return {
        location,
        CommonCellBuilder,
        gradeToMeasureMapper: selectors.getHistoricalGradeToMeasuresMapper(state),
        isGradeYearsFetching: selectors.isGradeYearsFetching(state),
        benchmarkHistoryData: selectors.getBenchmarkHistoryData(state),
        Table: StudentSummaryTable,
        infoBox: !selectors.isAcadienceReadingHidden(state) ? (
            <HistoricalDibelsBox
                classNames={classNames}
                classe={classe}
                studentId={studentId}
                url={studentSummaryUrl}
            />
        ) : (
            <></>
        ),
        wrappers: <>{resultId && <ProbeDetailsPageContainer resultId={resultId} />}</>,
    };
};

const mapDispatchToProps = dispatch => ({
    openProbeDetails: resultId => dispatch(openProbeDetails(resultId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExtendedTable);
